import type ApplicationModel from 'components/framework/ApplicationModel';
import { PageAction } from '../PageAction';
import { type RemoteAttributes } from '../RecordAction';
import { Page } from 'components/framework/models';

export class SaveAsTemplateAction extends PageAction {
  documentTypes = Page.DOCUMENT_TYPES_EXCEPT_LINKS;
  isRemoteLink = true;

  get title() {
    return 'Save as template';
  }

  get icon() {
    return 'fa-regular fa-table-layout';
  }

  remoteLinkAttributes(records): RemoteAttributes {
    const record = records[0];
    const { project, id } = record;

    const path = project
      ? `projects/${project.referencePrefix}/note_templates`
      : 'user_note_templates';

    return {
      href: `/settings/${path}/new?source_page_id=${id}`,
      method: 'get',
    };
  }

  showForDocumentType(documentType) {
    return !Page.DOCUMENT_TYPE_LINK.includes(documentType);
  }

  showForRecord(record: ApplicationModel): record is Page {
    return !!(
      super.showForRecord(record) &&
      this.showForDocumentType(record.documentType) &&
      this.selectedRecords.length === 1 &&
      // If it's not a hybrid account, we need either a knowledge or whiteboards
      // advanced plan
      (!window.currentAccount?.onlyNotebooksFlavor ||
        window.currentAccount?.knowledgeAdvanced ||
        window.currentAccount?.whiteboardsAdvanced ||
        // Otherwise we need the create note template permission in the project
        (record.project &&
          record.project.referencePrefix &&
          record.project.projectPermissions?.createNoteTemplates)) &&
      !record.isFolder
    );
  }
}
